/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import queryString from 'query-string';

const Form = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  React.useEffect(() => {
    const script = document.createElement("script");
    const parsed = queryString.parse(window.location.search);
    console.log(parsed);
    script.src = parsed.rec ? 
    `https://api.miniextensions.com/v1/iframe-embed/et5oJiEzSjJqr15MFS8p.js?absoluteShareUrl=https%3A%2F%2Fapp.miniextensions.com%2Fform%2Fet5oJiEzSjJqr15MFS8p%2F${parsed.rec}` 
    :
      `https://api.miniextensions.com/v1/iframe-embed/et5oJiEzSjJqr15MFS8p.js?absoluteShareUrl=https%3A%2F%2Fapp.miniextensions.com%2Fform%2Fet5oJiEzSjJqr15MFS8p${window.location.search}`;
      
    document.body.appendChild(script);
  }, []);

  return (
    <Box>
      <Box marginBottom={2}>
        <Typography
          variant={'h4'}
          sx={{ fontWeight: 700 }}
          gutterBottom
          align={'center'}
        >
          Business Questionnaire
        </Typography>
        <Box>
          <Typography color="text.secondary" align={'center'}>
            Please fill out this short form to get your maximum Employee Retention Credit
          </Typography>
        </Box>

      </Box>
      <Box
        maxWidth={600}
        margin={'0 auto'}
        sx={{
          '& .MuiOutlinedInput-root.MuiInputBase-multiline': {
            padding: 0,
          },
          '& .MuiOutlinedInput-input': {
            background: theme.palette.background.paper,
            padding: 2,
          },
        }}
      >
        <Grid container spacing={isMd ? 4 : 2}>
          <Grid item xs={12}>
          <div id="miniextensions-iframe-embed-et5oJiEzSjJqr15MFS8p"></div>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Form;
